import { render, staticRenderFns } from "./DomainRegistrationPackage.vue?vue&type=template&id=449543a6&"
import script from "./DomainRegistrationPackage.vue?vue&type=script&lang=js&"
export * from "./DomainRegistrationPackage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports